<!-- Only shown when web analytics is configured for this build; hidden in China where no data is collected. -->
@if (showNotice) {
	<span aria-hidden="true" class="separator">•</span>
	<a class="privacy-notice-link" href="javascript:void(0)" (click)="open()">Privacy &amp; Data</a>

	<!-- Informational analytics notice, shared wording from the SDK. No consent is collected. -->
	<p-drawer [dt]="drawerHeaderDesignToken" header="Privacy & Data" [(visible)]="visible" appendTo="body" position="right" [modal]="true" [closable]="true">
		@if (notice; as notice) {
			<div class="privacy-notice">
				<h4>{{ notice.full.title }}</h4>
				<p>{{ notice.full.intro }}</p>
				@for (section of notice.full.sections; track section.title) {
					<section class="privacy-notice__section">
						<h5>{{ section.title }}</h5>
						<p>{{ section.body }}</p>
					</section>
				}
			</div>
		}
	</p-drawer>
}
